import {Component} from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

class MonthYearInput extends Component {
    static propTypes = {
        dayOfMonth: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ])
    };

    static defaultProps = {
        dayOfMonth: 'first'
    };

    constructor(props) {
        super(props);
        const {value = ''} = props;
        this.state = {
            value: value ? moment.utc(value) : null
        };
    }

    getActualValue(value, asString = false) {
        let date, finalValue = null;
        const trimmed = value.substr(0, 7);
        const {dayOfMonth} = this.props;

        if (trimmed && trimmed.length === 7) {
            const [month, year] = trimmed.split('/');

            date = moment({
                month: month - 1,
                year
            });

            if (dayOfMonth === 'first') {
                date.startOf('month').startOf('date');
            } else if (dayOfMonth === 'last') {
                date.endOf('month').startOf('date');
            } else if (typeof dayOfMonth === 'number') {
                date.set('date', dayOfMonth).startOf('date');
            }
        }

        if (date && date.isValid()) {
            finalValue = asString ? moment.utc(date).startOf('date').toString() : moment.utc(date);
        }

        return finalValue;
    }

    getDisplayValue(value) {
        let displayValue = value.replace(/[^\d]/g, '').toString();
        const len = displayValue.length;

        if (len) {
            if (len <= 2) {
                const firstNumber = displayValue.substr(0, 1);
                const secondNumber = displayValue.substr(1, 1);

                if (len === 1 && (firstNumber !== '1' && firstNumber !== '0')) {
                    displayValue = '0' + displayValue;
                } else if (displayValue === '00') {
                    displayValue = '';
                } else if (firstNumber === '1' && Number(secondNumber) > 2) {
                    displayValue = firstNumber;
                }
            } else if (len >= 3) {
                displayValue = displayValue.substr(0, 2) + '/' + displayValue.substr(2, 4);
            }
        }

        return displayValue;
    }

    onChange(e) {
        const {handleYearMonthChange} = this.props;
        const {value} = e.target;
        this.setState({
            value: this.getDisplayValue(value)
        });

        const actualValue = this.getActualValue(value, true);
        handleYearMonthChange(actualValue);
    }

    getInputValue(value) {
        const date = moment.isMoment(value) ? value : this.getActualValue(value);
        if (date && date.isValid()) {
            return date.format('MM/YYYY');
        }

        return value;
    }

    render() {
        const {placeholder, input} = this.props;
        const {value} = this.state;

        return (
            <input
                type="tel"
                className="date-input"
                placeholder={placeholder}
                {...input}
                value={value ? this.getInputValue(value) : ''}
                onChange={this.onChange.bind(this)} />
        );
    }
}

export default MonthYearInput;
